"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import { Component } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { Flash } from "./flash";
const flashTransitionClassNames = {
  enter: "flash-transition-enter",
  enterActive: "flash-transition-enter-active",
  exit: "flash-transition-leave",
  exitActive: "flash-transition-leave-active"
};
class FlashMessages extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "messages", (messageArray, opts = {}) => {
      this.setState({ messages: messageArray, opts });
      this.hideEventually(opts.timeout ? opts.timeout : 1e4);
    });
    __publicField(this, "hideEventually", (timeout) => {
      clearTimeout(this.state.timeoutId);
      const timeoutId = window.setTimeout(this.clear, timeout);
      this.setState((prevState) => __spreadProps(__spreadValues({}, prevState), {
        timeoutId
      }));
    });
    __publicField(this, "clear", () => {
      this.setState((prevState) => __spreadProps(__spreadValues({}, prevState), {
        messages: []
      }));
    });
    __publicField(this, "hide", (idx) => {
      const newItems = [...this.state.messages];
      newItems.splice(idx, 1);
      this.setState((prevState) => __spreadProps(__spreadValues({}, prevState), {
        messages: newItems
      }));
    });
    __publicField(this, "undoLink", () => {
      const undo = this.state.opts.undo;
      if (undo) {
        return /* @__PURE__ */ jsx("a", { onClick: undo, className: "flash-messages__undo-link", children: "Undo." });
      }
    });
    __publicField(this, "_flashMap", {
      notice: "info",
      success: "success",
      warning: "warning",
      alert: "alert"
    });
    __publicField(this, "_flashClass", (level) => {
      const result = "alert-box small-12 medium-8 large-6 large-centered columns ";
      return result + (this._flashMap[level] || "");
    });
    this.state = {
      messages: this.props.messages || [],
      opts: {}
    };
  }
  componentWillMount() {
    Flash.init(this.messages.bind(this));
  }
  render() {
    const items = this.state.messages.map((message, index) => {
      const level = message[0];
      const text = message[1];
      return /* @__PURE__ */ jsx(
        CSSTransition,
        {
          classNames: flashTransitionClassNames,
          timeout: { enter: 500, exit: 300 },
          children: /* @__PURE__ */ jsxs("div", { className: this._flashClass(level), children: [
            text,
            "\xA0",
            this.undoLink(),
            /* @__PURE__ */ jsx("a", { className: "close", onClick: () => this.hide(index), children: "\xD7" })
          ] })
        },
        index
      );
    });
    return /* @__PURE__ */ jsx("div", { className: "flash-messages__component", "data-component": "FlashMessages", children: /* @__PURE__ */ jsx(TransitionGroup, { component: "span", children: items }) });
  }
}
__publicField(FlashMessages, "defaultProps", {
  messages: []
});
export { FlashMessages };
